import React from 'react'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { Button } from 'components/buttons'
import { useStyles } from './toggleButton.css'
import { localized } from 'decorators'

const ToggleButton = ({ localize, onMenuToggle, toggled }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Button
        variant='text'
        minWidth='inherit'
        width={25}
        title={localize('common.toggleMenu')}
        onClick={onMenuToggle}>
          {toggled && <ChevronLeftIcon />}
          {!toggled && <ChevronRightIcon />}
        </Button>
    </div>
  )
}

export default localized(ToggleButton)